<template>
  <div class="pagina-step">
    <span class="pagina-step-title">Porte populacional e IED</span>
    <div class="container-form">
      <ValidationObserver ref="observer" class="row c-gap">
        <div class="col-md-12 col-lg-12 col-12">
          <validation-provider v-slot="{ errors }" rules="required">
            <div>
              <span class="span-label"
                >Qual o porte populacional de <b>{{ cidadeEstado }}</b> segundo
                o IBGE?</span
              >
              <vue-select
                v-model="form.porte_populacional"
                :options="optionsPopulation"
                label="label"
                placeholder="Selecione"
              >
                <div slot="no-options">Não há opções correspondentes</div>
              </vue-select>
            </div>
            <div class="error">{{ errors[0] }}</div>
          </validation-provider>
        </div>
        <div class="col-md-12 col-lg-12 col-12">
          <validation-provider v-slot="{ errors }" rules="required">
            <div>
              <span class="span-label"
                >Qual o IED de <b>{{ cidadeEstado }}</b> segundo o
                Cofinanciamento federal?</span
              >
              <vue-select
                v-model="form.ied"
                :options="optionsIed"
                label="label"
                placeholder="Selecione"
              >
                <div slot="no-options">Não há opções correspondentes</div>
              </vue-select>
            </div>
            <div class="error">{{ errors[0] }}</div>
          </validation-provider>
        </div>
      </ValidationObserver>
    </div>
    <div class="container-buttons">
      <button type="button" @click="voltar">Voltar</button>
      <button @click="proximo">Avançar</button>
    </div>
  </div>
</template>

<script>
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import { TheMask } from 'vue-the-mask'

import VueSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { validations } from '@/mixins/validations'
validations()

import { optionsPortePopulacional, optionsIed } from './utils.js'

export default {
  components: {
    PulseLoader,
    'vue-select': VueSelect,
    ValidationObserver,
    ValidationProvider,
    TheMask,
  },
  props: {
    dados: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      form: {
        porte_populacional: '',
        ied: '',
      },
      optionsPopulation: optionsPortePopulacional,
      optionsIed: optionsIed,
    }
  },
  mounted() {
    if (this.dados?.etapa3 !== null) {
      const etapa3 = this.dados?.etapa3
      this.form.porte_populacional = etapa3.porte_populacional
      this.form.ied = etapa3.ied
    }
  },
  computed: {
    cidadeEstado() {
      return `${this.dados?.etapa1.cidade.no_municipio} - ${this.dados?.etapa1.estado.uf}`
    },
  },
  methods: {
    salvarDados() {
      this.$emit('dados-etapa', { etapa: 'etapa3', dados: this.form })
    },
    voltar() {
      this.$emit('etapa-anterior')
    },
    proximo() {
      this.$refs.observer.validate().then((success) => {
        if (success) {
          this.salvarDados()
          this.$emit('proxima-etapa')
        } else {
          this.$toast.warning('Preencha os campos obrigatórios!', 'Erro:', {
            position: 'topRight',
          })
        }
      })
    },
  },
}
</script>
<style scoped lang="scss" src="./styles.scss" />
